import './FluidImageLoading.scss';

import React, { useEffect, useState } from 'react';
import classNames from 'classnames';

import { FlexBox, FluidImage, Spinner } from '@vp/swan';

import { MediaLinkModel } from '@vp/digital-common-data-model-lib';

type FluidImageLoadingProps = {
  media?: MediaLinkModel;
  sizes?: string;
  useLoader?: boolean;
  className?: string;
  alt?: string;
};

const FluidImageLoading = ({
  media,
  sizes,
  useLoader = true,
  className,
  alt = media?.fileName || '',
}: FluidImageLoadingProps): JSX.Element => {
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(true);
  }, [media?.secureUrl]);

  return (
    <FlexBox
      alignItems="center"
      justifyContent="center"
      loadingShimmer={isLoading && !useLoader}
      className={classNames('image-loading__container', className)}
    >
      {useLoader && (
        <Spinner
          accessibleText="Loading..."
          visuallyHidden={!isLoading}
          className="image-loading__spinner"
        />
      )}

      <FluidImage
        alt={alt}
        srcSet={media?.resourceSetUrl}
        src={media?.secureUrl}
        sizes={sizes}
        style={{ opacity: isLoading ? '0' : '1' }}
        onLoad={() => {
          setIsLoading(false);
        }}
      />
    </FlexBox>
  );
};

export default FluidImageLoading;
